require('./passSuccessStep.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { toCamelCase } = require('utilities/stringHelper');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKLink } = require('commonsComponents/OKLink');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ constants
const { EURO_TEXT, FIRST_STEP, EMPTY_CONCEPT } = require('constants/index');

class PassSuccessStep extends React.Component {

    render() {
        const { immPassState, originAccount, destinationAccount } = this.props;
        const firstStep = immPassState.getIn(['steps', FIRST_STEP]);
        const isToday = firstStep.get('isToday');
        const title = isToday ? formatText('passSuccessStep-title') : formatText('passSuccessStep-futureTitle');
        const originAccountAlias = originAccount.get('alias') || toCamelCase(originAccount.get('accountType'));
        const destinationAccountAlias = destinationAccount.get('alias') || toCamelCase(destinationAccount.get('accountType'));
        const concept = firstStep.get('concept') || EMPTY_CONCEPT;
        const amountObject = {
            amount: firstStep.get('amount'),
            currency: EURO_TEXT
        };
        const plainAmountObject = getPlainAmountObject(amountObject);

        return (
            <WizardSuccess
                successMessage={title}
                customClassName="pass-success-step"
            >
                <div>
                    <OKInformativeList columns={2}>
                        <OKInformativeListItem
                            title="passSuccessStep-originAccount"
                            bodyText={originAccountAlias}
                        />
                        <OKInformativeListItem
                            title="passSuccessStep-concept"
                            bodyText={concept}
                        />
                        <OKInformativeListItem
                            title="passSuccessStep-destinationAccount"
                            bodyText={destinationAccountAlias}
                        />
                        <OKInformativeListItem title="passSuccessStep-import">
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                className="pass-success-step__amount"
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                        </OKInformativeListItem>
                    </OKInformativeList>

                    <div className="pass-success-step__separator" />

                    <div className="clearfix">
                        <div className="pull-right pass-success-step__back-link">
                            <OKLink modifier="complementary" to="/myprofile/transfers/">
                                <FormattedText value="passSuccessStep-back" />
                            </OKLink>
                        </div>
                    </div>
                </div>
            </WizardSuccess>
        )
    }
}

PassSuccessStep.propTypes = {
    immPassState: PropTypes.object,
    originAccount: PropTypes.object,
    destinationAccount: PropTypes.object
};

module.exports = PassSuccessStep;